import { configureStore } from "@reduxjs/toolkit";
import pageReducer from "./pageSlice";
import userReducer from "./userSlice";
import commentsReducer from "./commentsSlice";
export var store = configureStore({
    reducer: {
        page: pageReducer,
        user: userReducer,
        comments: commentsReducer,
    },
});
